const getAdSpecificTargeting = ({ adverts: { adSpecificTargeting } }) =>
  adSpecificTargeting;

export default getAdSpecificTargeting;
